import React, { useEffect, useRef, useState } from 'react'
import Reveal from 'components/Reveal'

const STATS = [
  { prefix: '+', target: 100, suffix: '', label: 'Clientes atendidos' },
  { prefix: '', target: 4, suffix: ' anos', label: 'De experiência' },
  { prefix: '+', target: 1500, suffix: '', label: 'Projetos entregues' },
  { prefix: '', target: 98, suffix: '%', label: 'Taxa de satisfação' },
]

function CountUp({ target, prefix, suffix, duration = 1600 }) {
  const ref = useRef(null)
  const [value, setValue] = useState(0)
  const started = useRef(false)

  useEffect(() => {
    const node = ref.current
    if (!node) return

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !started.current) {
          started.current = true
          const start = performance.now()

          const step = now => {
            const progress = Math.min((now - start) / duration, 1)
            const eased = 1 - Math.pow(1 - progress, 3)
            setValue(Math.round(target * eased))
            if (progress < 1) requestAnimationFrame(step)
          }

          requestAnimationFrame(step)
          observer.disconnect()
        }
      },
      { threshold: 0.4 },
    )

    observer.observe(node)
    return () => observer.disconnect()
  }, [target, duration])

  return (
    <div
      ref={ref}
      className='mb-2 whitespace-nowrap font-display text-3xl font-black sm:text-5xl md:text-7xl'
      style={{ color: '#FFE98C' }}
    >
      {prefix}
      {value.toLocaleString('pt-BR')}
      {suffix}
    </div>
  )
}

function Stats() {
  return (
    <section className='section-h-half dorac-grid-bg-dark'>
      <div className='container mx-auto px-4'>
        <div className='grid grid-cols-2 gap-x-6 gap-y-10 md:grid-cols-4 md:gap-10'>
          {STATS.map((stat, index) => (
            <Reveal key={stat.label} delay={index * 100} className='text-center'>
              <CountUp prefix={stat.prefix} target={stat.target} suffix={stat.suffix} />
              <div className='text-xs font-medium text-white sm:text-base'>{stat.label}</div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Stats
